var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recension"},[_c('a',[_vm._v(_vm._s(_vm.username))]),(_vm.stars)?_c('RatingComponent',{attrs:{"selected":_vm.stars}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }